// @ts-nocheck 20baf0bf
import type { IPageMenuItem } from '#packages/menu';
import type { MenuData, MenuItem } from '@wix/document-services-types';
import _ from 'lodash';
import type { EditorAPI } from '#packages/editorAPI';
import { utils as menuUtils } from '@/menu';
import { getMainPagesIds } from '#packages/panels';
import {
  WIX_BLOG,
  WIX_BOOKINGS,
  WIX_EVENTS,
  WIX_GROUPS,
  WIX_CHALLENGES,
  WIX_NEW_STORES,
  WIX_PORTFOLIO,
  WIX_RESTAURANTS_ORDERS_NEW,
  MEMBERS_AREA,
  WIX_HOTELS_RUNNER,
} from '@wix/app-definition-ids';

const getMenuItemsWithInitialCollaptionData = (menuItems, collaptionMap) => {
  //TODO: once more then 2 levels of menu will be opened make this function recursive. For now keep it simple and efficient
  if (collaptionMap) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line you-dont-need-lodash-underscore/for-each
    _.forEach(menuItems, (menuItem) => {
      menuItem.isCollapsed = collaptionMap[menuItem.id];
    });
  }

  return menuItems;
};

const getMenuItemsWithsymbolIfApplicable = (
  menuItems,
  menuAppDefId,
  membersAppDefId,
) => {
  if (menuAppDefId !== membersAppDefId) {
    return menuItems;
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/map
  return _.map(menuItems, (menuItem) =>
    _.defaults(
      {
        symbol: 'membersAction',
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line you-dont-need-lodash-underscore/map
        items: _.map(menuItem.items, (item) =>
          _.defaults({ symbol: 'membersAction' }, item),
        ),
      },
      menuItem,
    ),
  );
};

const findItemInHierarchy = (
  hierarchy: MenuData,
  item: IPageMenuItem | MenuItem,
) => {
  if (!item || !hierarchy || !hierarchy.items?.length) {
    return null;
  }

  for (const hItem of hierarchy.items) {
    if (hItem.id === item.id) {
      return hItem;
    } else if (hItem.items?.length) {
      const result = findItemInHierarchy(hItem, item);
      if (result) {
        return result;
      }
    }
  }

  return null;
};

const getFirstPageOfAppID = (appID: string, editorAPI: EditorAPI) => {
  const pages = menuUtils.getPagesWithVerticalsDynamic(editorAPI);
  const mainPagesIds = getMainPagesIds(pages);

  const verticalsPages = pages.filter(
    (page) => !mainPagesIds.includes(page.id),
  );

  const [firstPage] = verticalsPages.filter(
    (page) => page.appDefinitionId === appID || page.managingAppDefId === appID,
  );
  return firstPage ? firstPage : null;
};

const generateBIForAppID = (appID: string) => {
  switch (appID) {
    case WIX_BLOG:
      return 'blog';
    case WIX_BOOKINGS:
      return 'bookings';
    case WIX_NEW_STORES:
      return 'stores';
    case WIX_HOTELS_RUNNER:
      return 'hotels';
    case WIX_GROUPS:
      return 'groups';
    case WIX_RESTAURANTS_ORDERS_NEW:
      return 'restaurants';
    case WIX_CHALLENGES:
      return 'programs';
    case WIX_PORTFOLIO:
      return 'portfolio';
    case WIX_EVENTS:
      return 'events';
    case MEMBERS_AREA:
      return 'members';
    default:
      return '';
  }
};

const generateLinkForAppID = (
  appID: string,
  targetPage: PagesData,
  editorAPI: EditorAPI,
) => {
  const wixBasicLinkVerticals = [
    WIX_GROUPS,
    WIX_BOOKINGS,
    WIX_RESTAURANTS_ORDERS_NEW,
    WIX_EVENTS,
    WIX_CHALLENGES,
    WIX_PORTFOLIO,
    WIX_HOTELS_RUNNER,
  ];

  if (wixBasicLinkVerticals.includes(appID)) {
    return {
      type: 'PageLink',
      pageId: `#${targetPage.id}`,
    };
  }

  if (appID === WIX_BLOG) {
    return {
      appDefinitionId: WIX_BLOG,
      itemTypeIdentifier: 'wix.blog.sub_pages.category',
      pageId: `#${targetPage.id}`,
      type: 'TpaPageLink',
      itemId: '12345678-1234-1234-1234-123456789123',
      path: '/blog',
    };
  }

  if (appID === WIX_NEW_STORES) {
    return {
      routerId: editorAPI.dsRead.routers.getRouterDataForPageIfExist(
        targetPage.id,
      ).routerId,
      type: 'DynamicPageLink',
      pageId: `#${targetPage.id}`,
    };
  }

  if (appID === MEMBERS_AREA) {
    return {
      appDefinitionId: MEMBERS_AREA,
      itemTypeIdentifier: 'wix.members_area.sub_pages.tab',
      pageId: `#${targetPage.id}`,
      type: 'TpaPageLink',
      itemId: '14dd1af6-3e02-63db-0ef2-72fbc7cc3136',
      path: '/account-settings/my/my-account',
    };
  }
};

export {
  getMenuItemsWithInitialCollaptionData,
  getMenuItemsWithsymbolIfApplicable,
  findItemInHierarchy,
  getFirstPageOfAppID,
  generateLinkForAppID,
  generateBIForAppID,
};
